import * as React from 'react';

import PieChart from 'components/graphs/echarts/pie-chart/PieChart';

import StatisticsAudienceTotal from './StatisticsAudienceTotal';

import { displayPieChart, preparePieChartData } from 'utils/charts/pie-chart';

import type { PieChart as PieChartType } from 'types';

type Props = {
  data: Array<PieChartType>
};

const getTotalAudience = (data: Array<PieChartType>): number => {
  let total = 0;

  (data || []).forEach(item => {
    total += item.metric || 0;
  });

  return total;
};

const StatisticsAudienceOverlap = (
  {
    data
  }: Props
): JSX.Element => {
  const pieChartData = preparePieChartData(data, 'audience');
  const totalAudience = getTotalAudience(data);

  return (
    <div className="statistics-audience-overlap">
      <div className="statistics-audience-overlap__chart">
        <PieChart
          id="statistics-audience-overlap"
          options={pieChartData}
          hide={!displayPieChart(data)}
        />
      </div>
      <StatisticsAudienceTotal totalAudience={totalAudience} />
    </div>
  );
};

export default StatisticsAudienceOverlap;
